import { openLightbox } from '../../js/front/components/lightbox';

document.querySelectorAll( '.b-typeform--has-teaser' ).forEach( ( block ) => {

	const trigger = block.querySelector( '.js-typeform-teaser-trigger' );
	if ( ! trigger ) {

		return;

	}

	const embedSection = block.querySelector( '.js-typeform-embed' );
	const teaser       = block.querySelector( '.js-typeform-teaser' );
	const buttonAction = trigger.dataset.buttonAction ?? 'article';

	if ( buttonAction === 'fullscreen' && embedSection ) {

		document.addEventListener( 'beforeOpenLightbox', ( event ) => {

			if ( event.detail.content !== embedSection ) {

				return;

			}
			embedSection.hidden = true;


		} );

	}

	trigger.addEventListener( 'click', ( event ) => {

		if ( buttonAction === 'fullscreen' ) {

			if ( embedSection ) {

				// Temporarily remove hidden so cloneNode copies a visible element
				embedSection.hidden = false;

				openLightbox( embedSection, {
					lightboxClass: 'c-lightbox--no-padding',
					overlayClass: 'c-lightbox__overlay--adaptive',
					opener: event.currentTarget
				} );

			}

			trigger.setAttribute( 'aria-expanded', 'true' );

			return;

		}

		// Default: inline reveal
		if ( teaser ) {

			teaser.hidden = true;
			teaser.classList.add( 'b-typeform-teaser--hidden' );

		}

		if ( embedSection ) {

			embedSection.hidden = false;
			embedSection.classList.add( 'b-typeform__embed--visible' );

		}

		trigger.setAttribute( 'aria-expanded', 'true' );

	} );

} );
